export class SubMenuItem {
    isActive: boolean = false;

    public constructor(
        public url: string,
        public name: string,
        public classes: string = null,
        public active: boolean = true
    ) {}
}
